export default __webpack_public_path__ + "static/media/list.6e567961.svg";